import axiosInstance from '@/utils/api.js'

var state = {
  internalTransfer: []
}

var getters = {
  INTERNAL_TRANSFER: (state) => {
    return state.internalTransfer
  }
}

var mutations = {
  SET_INTERNAL_TRANSFER: (state, payload) => {
    state.internalTransfer = payload
  }
}

var actions = {
  GET_INTERNAL_TRANSFER: async (context, payload) => {
    let result = await axiosInstance.get('/reports/funds_flows?start=' + payload.numDateStart +
    '&end=' + payload.numDateEnd +
    '&user_id=' + payload.userId +
    '&limit=' + payload.limit +
    '&download=' + payload.download, {timeout: 45000})
    if (result.status === 200) {
      context.commit('SET_INTERNAL_TRANSFER', result.data)
    }
  },
  CLEAR_INTERNAL_TRANSFER: (context) => {
    context.commit('SET_INTERNAL_TRANSFER', [])
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/reports/internalTransfer.js